import { Component, inject, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";

import { FooterComponent } from "../shared/footer/footer.component";
import { HeaderComponent } from "../shared/header/header.component";
import { APIResults } from "../sharedinterfaces";

@Component({
	selector: "app-support",
	templateUrl: "./support.component.html",
	styleUrls: ["./support.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class SupportComponent implements OnDestroy {
	private router = inject(Router);

	private activeRouteComponent: any;

	ngOnDestroy(): void {
		this.selectedSubscription?.unsubscribe();
	}

	private selectedSubscription: any;
	public updateRouterOutlet(routecomponent?: any) {
		this.selectedSubscription?.unsubscribe();
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			if (this.activeRouteComponent.AssetSelected) {
				this.selectedSubscription = this.activeRouteComponent.AssetSelected.subscribe(async (asset: APIResults.Asset) => {
					this.router.navigate([`/dash/fleet/${asset.fleet_id}/asset/${asset.asset_id}`]);
				});
			}
		}
	}
}
